import { ref } from 'vue';

export const showInvitation = ref(false);
